import { AnyAction } from 'redux';
import { ErrorReducer } from '../reducers/error';
import { SET_ERROR, CLEAR_ERROR } from './actionTypes';

export interface ErrorAction extends AnyAction {
    type: string;
    payload?: ErrorReducer;
}

const setError = (payload: ErrorReducer): ErrorAction => ({
    type: SET_ERROR,
    payload: payload,
});

const clearError = (): ErrorAction => ({
    type: CLEAR_ERROR,
});

export default {
    setError,
    clearError,
};
